import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IInvoiceResponse, IInvoiceState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowInvoice = createAsyncThunk(
  'listInvoices/fetchShowInvoice',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.invoice(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IInvoiceState = {
  isLoading: false,
  response: null,
  error: null
}

const showInvoiceSlice = createSlice({
  name: 'invoices/show',
  initialState,
  reducers: {
    resetShowInvoice: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowInvoice.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowInvoice.fulfilled, (state, action: PayloadAction<IInvoiceResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowInvoice.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showInvoiceSlice.reducer
export const { resetShowInvoice } = showInvoiceSlice.actions
